import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SidebarService } from '../sidebar/sidebar.service';
import { TranslateService } from '@ngx-translate/core';
import { MsalService } from '@azure/msal-angular';
import { Observable } from 'rxjs';
import { DarkModeService } from 'src/app/@core/services/dark-mode/dark-mode.service'

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent {

  langList: string[] = ["en", "es"];
  currentLang: string = this.translateService.currentLang;
  email: string = "";

  constructor(
    private sidebar: SidebarService,
    private router: Router,
    public translateService: TranslateService,
    private authService: MsalService,
    public darkModeService: DarkModeService
  ) {
    let payload: any = this.authService.instance.getAllAccounts()[0];
    this.email = payload.username;
  }

  goHome() {
    this.router.navigateByUrl('/');
  }

  toggleRightSidenav() {
    this.sidebar.toggle();
  }

  login() {
    const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;
    if (isIE) {
      this.authService.loginRedirect();
    } else {
      this.authService.loginPopup();
    }
  }

  logout() {
    this.authService.logout();
  }

  onChangeLanguage(value: string) {
    this.currentLang = value;
    this.translateService.use(value);
  }

  setDarkMode(darkMode: boolean) {
    document.body.classList.toggle('darkMode')
    this.darkModeService.setDarkMode(darkMode)
  }

}
